import dynamic from 'next/dynamic';

import Box from 'shopper/components/Box';
import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import SocialMediaLoginButtonsGroup from 'components/SocialMediaLoginButtonsGroup';

import useDialog from 'hooks/useDialog';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import Disclaimer from './Disclaimer';

const LoginDialog = dynamic(() => import('components/LoginDialog'), {
  ssr: false,
});
const GA_EVENT_CATEGORY = 'sidebar';

const SignInOptionsContainer = () => {
  const { showDialog } = useDialog();

  const onSignUpButtonClickHandler = () => {
    sendEvent({
      action: 'modal_login',
      category: GA_EVENT_CATEGORY,
    });

    showDialog(LoginDialog);
  };

  return (
    <Box className="flex h-full w-[324px] flex-col items-center justify-between gap-4 rounded-5 border-2 border-neutral-high-300 p-4">
      <Text className="text-center">
        {placeholder('descriptions.signInOptions')}
      </Text>
      <div className="flex flex-col items-center gap-3">
        <SocialMediaLoginButtonsGroup gaEventCategory={GA_EVENT_CATEGORY} />
        <Button
          className="w-full rounded-3 border border-neutral-high-300"
          size="size4"
          type="neutral-ghost"
          onClick={onSignUpButtonClickHandler}
        >
          <Icon name="email" />
        </Button>
      </div>
      <Disclaimer />
    </Box>
  );
};

export default SignInOptionsContainer;
